import { Box } from 'grommet';
import { observer } from 'mobx-react-lite';
import { AddNewButton } from '../../AddNewButton';
import { useEstimateStore } from '@talon/web/src/context';

export interface ISessionEstimateFooterProps {
  addEstimateItem: () => void;
}

export const SessionEstimateFooter = observer(({ addEstimateItem }: ISessionEstimateFooterProps) => {
  const estimateStore = useEstimateStore();

  return (
    <Box
      gap="small"
      pad={{ vertical: 'small', horizontal: 'medium' }}
      background="white"
      border={{ side: 'top', color: 'border-divider' }}
    >
      {estimateStore.canEditCurrent && (
        <Box width="15%" pad={{ vertical: 'xsmall' }}>
          <AddNewButton plain label="Add item" tipText="Add estimate item" onClick={addEstimateItem} />
        </Box>
      )}
    </Box>
  );
});
